export default "__VITE_ASSET__XqJUt9Uq__"